import { render, staticRenderFns } from "./NewPromotion.vue?vue&type=template&id=b4d79c5a&"
import script from "./NewPromotion.vue?vue&type=script&lang=js&"
export * from "./NewPromotion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports